<template>
  <div class="proj-rule-view-digital-item" v-if="ruleDigitalItem.ruleResult">
    <div class="rule-name">
      <el-tooltip :disabled="ruleDigitalItem.ruleName.length <= 7" :content="ruleDigitalItem.ruleName" placement="top">
        <span>{{ ruleTypeItemIndex+1 }}.{{ruleDigitalItemIndex+1}} {{ ruleDigitalItem.ruleName }}</span>
      </el-tooltip>
    </div>
    <div class="rule-view-area">
      <template v-for="(contentItem, $index) in ruleDigitalItem.ruleContent">
        <template v-if="contentItem.type == 'images'">
          {{contentItem.content}}
        </template>

        <template v-if="contentItem.type == 'text'">
          {{contentItem.content}}
        </template>

        <template v-if="contentItem.type == 'radio' && contentItem.isCheck">
          {{contentItem.content}}
        </template>

        <template v-if="contentItem.type == 'radioText' && contentItem.isCheck">
          {{contentItem.content}}
        </template>

        <template v-if="contentItem.type == 'buyerfile'">
          {{contentItem.content}}
          <EbDownLoadFile :fileUrl="contentItem.url" style="margin-top: -10px;" :key="$index"/>
        </template>

        <template v-if="contentItem.type == 'supplierfile'">
          {{contentItem.content}}
        </template>

        <template v-if="contentItem.type == 'text-detail'">
          {{contentItem.content}}
        </template>
      </template>
    </div>
  </div>
</template>

<script>
// import EventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios.js';
import { downloadFile } from '@/plugins/download-file';
import EbDownLoadFile from '@/components/common/eb-download-file';

export default {
  props: {
    ruleTypeItemIndex: {
      type: Number,
      required: true
    },
    ruleDigitalItem: {
      type: Object,
      required: true
    },
    ruleDigitalItemIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  components: {
    EbDownLoadFile
  },
  created() {
    // console.info(this.ruleDigitalItem, 'ruleDigitalItem');
    this.ruleDigitalItem.ruleContent.forEach((item, idx) => {
      if (item.type === 'buyerfile') {
        item.fileList = this.trunsToUploadFilelist(item.url);
      }
    });
  },
  watch: {},
  methods: {
    trunsToUploadFilelist(fileUrl) {
      if (fileUrl && fileUrl.length > 0) {
        return [{ name: this.$options.filters['projFileName'](fileUrl), url: fileUrl }];
      } else {
        return [];
      }
    },
    // 文件下载
    handleBuyerFilePreview(file) {
      downloadFile(baseURL + file.url, this.$options.filters['projFileName'](file.url));
    }
  }
};
</script>

<style lang="less">
.proj-rule-view-digital-item {
  line-height: 38px;
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: baseline; /*指定基线居中*/

  .rule-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 232px;
    min-width: 232px;
    display: inline-block;
  }
  // .rule-view-area {
  //   width: 578px;
  // }
  .eb-file-uploaded {
    .el-upload {
      display: none;
    }
  }
}
</style>
